import { toast } from '@/components/toast';
import { logger } from '@/services/logger';
import imglyBackgroundRemoval from '@imgly/background-removal';
import useDirectUpload from './image-upload/useDirectUpload';

const useBackgroundRemoval = () => {
    const { mutateAsync: directUpload } = useDirectUpload();

    const removeBackground = async (imageUrl: string, id: string, bucket: string): Promise<string | undefined> => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const imageBlob = await imglyBackgroundRemoval(blob);

            const file = new File([imageBlob], 'image-removed_bg.png', {
                type: 'image/png',
            });
            const res = await directUpload({ file, metadata: { bucket, image_id: id } });
            if (!res) {
                throw new Error('No response from direct upload');
            }
            return res.url;
        } catch (error) {
            logger.error('Error during removing background', error);
            toast.error({ title: 'Error while removing background. Please try again', toastId: `background-remove-error` });
        }
    };

    return { removeBackground };
};

export default useBackgroundRemoval;
